import { EmergencyNotificationAcknowledgedEvent } from '@dreryk/egabinet-emergency-notification-frontend-api';

import { useCqrsEvent } from '@dreryk/command-query-react-common';

import { useEmergencyNotification } from './useEmergencyNotification';

export const EmergencyNotificationAcknowledgedEventListener = (): null => {
   const { acknowledge } = useEmergencyNotification();

   useCqrsEvent<EmergencyNotificationAcknowledgedEvent>(
      'egabinet-emergency-notification-frontend-api:EmergencyNotificationAcknowledgedEvent',
      (event) => acknowledge(event.notificationId)
   );

   return null;
};
